import { Session } from "ezStore";
import { Control, Controller } from "react-hook-form";
import { Fields, hasOptionalFieldPermission, Language } from "utils";
import { FormGroup } from "@cofano/cck";
import RelationSelect from "view/relations/components/selects/RelationSelect";
import { RelationType } from "__generated__/graphql";
import { CargoForm } from "types/index";

const CargoRelations = ({ control, session }: { control: Control<CargoForm>, session: Session }) => {
	return (
		<>
			<FormGroup label={Language("SUPPLIER")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="supplier"
					control={control}
					render={({ field }) => (
						<RelationSelect
							{...field}
							types={[ RelationType.Supplier ]}
							onChange={option => field.onChange(option ? { id: option.id, name: option.name } : null)} />
					)} />
			</FormGroup>

			<FormGroup label={Language("CARGO_CONSIGNOR")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="consignor"
					control={control}
					render={({ field }) => (
						<RelationSelect
							{...field}
							onChange={option => field.onChange(option ? { id: option.id, name: option.name } : null)} />
					)} />
			</FormGroup>

			<FormGroup label={Language("ORDER_CONSIGNEE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="consignee"
					control={control}
					render={({ field }) => (
						<RelationSelect
							{...field}
							onChange={option => field.onChange(option ? { id: option.id, name: option.name } : null)} />
					)} />
			</FormGroup>

			{hasOptionalFieldPermission(session, Fields.ORDER, "containerOperator") && (
				<FormGroup label={Language("CONTAINER_OPERATOR")} labelPlacement="left-center" overflow="hidden">
					<Controller
						name="containerOperator"
						control={control}
						render={({ field }) => (
							<RelationSelect
								{...field}
								onChange={option => field.onChange(option ? { id: option.id, name: option.name } : null)} />
						)} />
				</FormGroup>
			)}
		</>
	);
};

export default CargoRelations;
